import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

const Tooltip = ({ text, tooltipName, duration }) => {
  const [shown, setShown] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let shownTimer = null;
    let hiddenTimer = null;
    if (text !== '') {
      shownTimer = window.setTimeout(() => {
        setShown(true);
        setHidden(false);
        hiddenTimer = window.setTimeout(() => setHidden(true), 500);
      }, duration);
    }
    return () => {
      window.clearTimeout(shownTimer);
      window.clearTimeout(hiddenTimer);
      setShown(false);
      setHidden(false);
    };
  }, [text]);

  if (text === '') { return null; }

  const tooltipClassName = classnames('floating-nav__item--tooltip', {
    'tooltip-appear-active': !shown && !hidden,
    'tooltip-leave-active': shown && !hidden,
    'tooltip-leave': shown && hidden,
  });

  return (
    <div className="floating-nav__item--tooltip-container">
      <div className={tooltipClassName} id={`js-${tooltipName}-link-tooltip`}>
        {text}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  duration: PropTypes.number,
  tooltipName: PropTypes.string.isRequired,
};

Tooltip.defaultProps = {
  duration: 4000,
};

const mapStateToProps = (state, ownProps) => ({
  text: state.floatingNavigation[ownProps.tooltipName],
});

export default connect(mapStateToProps)(Tooltip);
